import React from 'react';
import { AntSchema, FieldType } from '../types';
import some from 'lodash/some';
import { Input, Row } from 'antd';
import { RowProps } from 'antd/es/grid';
import renderFieldItem from './renderFieldItem';

type FieldsGroupProps = {
  fields: AntSchema;
  errors: any;
  options?: {
    fieldKey?: string | number;
    fieldName?: string | number;
    readOnly?: boolean;
    locale?: string;
  };
  rowProps?: RowProps;
};

const FieldsGroup: React.FC<FieldsGroupProps> = (props) => {
  const { fields, errors, rowProps, options = {} } = props;
  if (!fields) return null;
  const withRow = some(fields, (field) => (field as FieldType)?.colProps);

  const formItems = fields.map((item, i) =>
    renderFieldItem(item, errors, {
      rowProps,
      key: i,
      ...(options || {}),
    }),
  );

  return (
    <Input.Group compact={!withRow}>
      {withRow ? <Row {...(rowProps || {})}>{formItems}</Row> : formItems}
    </Input.Group>
  );
};

export default FieldsGroup;
